import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'

const useSmsPhoneNumberCollectionFeature = () => {
  const { flagValue } = useFeatureFlag('24f_ff_registry_sms_frontend', false)

  return flagValue
}

export default useSmsPhoneNumberCollectionFeature
